import { Helmet } from 'react-helmet-async'
import { Columns, Column, Hidden, Box } from '@machobear/design-system'
import PageTitle from '@/components/page-title'
import { structure } from '@/styles'
import SideMenu from '../components/SideMenu'
import MobileMenu from '../components/MobileMenu'

const BaseLayout = ({ children, title = '' }: { children: React.ReactNode; title: string }) => {
  return (
    <>
      {!!title && (
        <>
          <Helmet>
            <title>{title}</title>
          </Helmet>
          <PageTitle>{title}</PageTitle>
        </>
      )}
      <Box
        background="body"
        zIndex="dropdownBackdrop"
        position="sticky"
        style={{ top: structure.header.heightMobile }}
      >
        <Hidden above="mobile">
          <MobileMenu />
        </Hidden>
      </Box>
      <Columns collapseBelow="tablet" space="none">
        <Hidden below="tablet">
          <Column width="1/5">
            <SideMenu />
          </Column>
        </Hidden>
        <Column>{children}</Column>
      </Columns>
    </>
  )
}

export default BaseLayout
